/**
 * The tabs of Shopify → Sales, in the strip's order: the box units bought at checkout, the $0
 * orders their claims ship as, and the store credit waiting on Shopify. The tab rides the URL
 * (`?tab=`), so a tab is a link: the overview's waiting counts land on theirs. The Shopify area
 * is admin-only, so every member who reaches it sees every tab.
 */
export const SHOPIFY_SALES_TABS = ["purchases", "orders", "store-credit"] as const;
export type ShopifySalesTab = (typeof SHOPIFY_SALES_TABS)[number];

export const SHOPIFY_SALES_TAB_LABELS: Record<ShopifySalesTab, string> = {
  purchases: "Purchases",
  orders: "Orders",
  "store-credit": "Store credit",
};

export function isShopifySalesTab(value: unknown): value is ShopifySalesTab {
  return typeof value === "string" && (SHOPIFY_SALES_TABS as readonly string[]).includes(value);
}

export interface ShopifySalesSearch {
  tab?: ShopifySalesTab;
}

/** The route's `validateSearch`: an unknown tab is dropped, and the page shows Purchases. */
export function parseShopifySalesSearch(search: Record<string, unknown>): ShopifySalesSearch {
  return { tab: isShopifySalesTab(search.tab) ? search.tab : undefined };
}

/** The tab to show: the requested one, else Purchases. */
export function resolveShopifySalesTab(requested: ShopifySalesTab | undefined): ShopifySalesTab {
  return requested ?? "purchases";
}
